import { render, staticRenderFns } from "./WhiteLabel.vue?vue&type=template&id=15967d28"
import script from "./WhiteLabel.vue?vue&type=script&lang=ts"
export * from "./WhiteLabel.vue?vue&type=script&lang=ts"
import style0 from "./WhiteLabel.vue?vue&type=style&index=0&id=15967d28&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports